import React, { useEffect } from "react";

export default function () {
  const [orientation, setOrientation] = React.useState(() => {
    return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
  });

  useEffect(() => {
    const handleOrientationChange = () => {
      setTimeout(() => {
        const newOrientation =
          window.innerWidth > window.innerHeight ? "landscape" : "portrait";
        setOrientation(newOrientation);
      }, 100);
    };

    window.addEventListener("orientationchange", handleOrientationChange);
    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return orientation;
}
